import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { datadogLogs } from '@datadog/browser-logs';
import PropTypes from 'prop-types';
import { CARD_PAYMENT_METHODS } from '../../../../constants/CardPaymentMethod';

// Cardinal posts its device-data-collection result as stringified JSON; other
// window messages may be plain objects or arbitrary strings.
const parseCardinalMessage = data => {
  if (typeof data !== 'string') {
    return data && typeof data === 'object' ? data : {};
  }

  try {
    return JSON.parse(data) || {};
  } catch (error) {
    return {};
  }
};

class CardDeviceDataCollectionComponent extends Component {
  constructor(props) {
    super(props);

    this.authenticatePayerTriggered = false;
    this.initiateCardinalAuthPayer = this.initiateCardinalAuthPayer.bind(this);
  }

  componentDidMount() {
    const { store } = this.props;
    const sourceId = store.source.id;
    const cardinalCollectionForm = document.querySelector('#cardinal_collection_form');

    try {
      if (cardinalCollectionForm) {
        store.setPageLoading(true);
        store.setPageLoadingText('Kindly wait while we set up the authentication process for you.');

        datadogLogs.logger.info('Cardinal Card Device Data Collection initiated', {
          data: { source_id: sourceId }
        });

        cardinalCollectionForm.submit();

        store.setPageLoadingText(
          'Securely passing your device information to your bank for checking.'
        );
      }
    } catch (error) {
      datadogLogs.logger.info('Cardinal Card Device Data Collection failed', {
        data: { errors: error.message, source_id: sourceId }
      });

      store.fail({
        auth_token_response: store.source.redirect.auth_token,
        error_code: 400,
        error_description: error.message
      });

      store.setPageLoadingText(null);
    }

    window.addEventListener('message', this.initiateCardinalAuthPayer, false);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.initiateCardinalAuthPayer, false);
  }

  initiateCardinalAuthPayer(event) {
    const { store } = this.props;
    const sourceId = store.source.id;

    try {
      const collectionOrigin = new URL(store.source.cardDeviceDataCollection.url).origin;

      if (event.origin !== collectionOrigin) {
        return;
      }

      const message = parseCardinalMessage(event.data);

      if (message.MessageType !== 'profile.completed') {
        datadogLogs.logger.info('Cardinal DDC message ignored', {
          data: {
            event_data: event.data,
            event_origin: event.origin,
            message_type: message.MessageType || null,
            source_id: sourceId
          }
        });

        return;
      }

      if (store.source.status !== 'pending' || !CARD_PAYMENT_METHODS.includes(store.source.type)) {
        return;
      }

      if (this.authenticatePayerTriggered) {
        datadogLogs.logger.info('Cardinal Authenticate Payer duplicate trigger suppressed', {
          data: {
            event_data: event.data,
            event_origin: event.origin,
            source_id: sourceId
          }
        });

        return;
      }

      this.authenticatePayerTriggered = true;

      datadogLogs.logger.info('Cardinal Authenticate Payer initiated', {
        data: {
          event_data: event.data,
          event_origin: event.origin,
          source_id: sourceId
        }
      });

      store.authenticatePayer();
    } catch (error) {
      datadogLogs.logger.info('Cardinal Authenticate Payer Failed', {
        data: { errors: error.message, source_id: sourceId }
      });

      store.setPageLoadingText(null);
    }
  }

  render() {
    const { store } = this.props;

    return (
      <div>
        <iframe
          id="cardinal_collection_iframe"
          name="collectionIframe"
          height="10"
          width="10"
          style={{ display: 'none' }}
          title="Cardinal Collection"
        />
        <form
          id="cardinal_collection_form"
          method="POST"
          target="collectionIframe"
          action={store.source.cardDeviceDataCollection.url}
        >
          <input
            id="cardinal_collection_form_input"
            type="hidden"
            name="JWT"
            value={store.source.cardDeviceDataCollection.accessToken}
          />
        </form>
      </div>
    );
  }
}

CardDeviceDataCollectionComponent.propTypes = {
  store: PropTypes.shape({
    authenticatePayer: PropTypes.func,
    fail: PropTypes.func,
    source: PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      cardDeviceDataCollection: PropTypes.shape({
        accessToken: PropTypes.string,
        provider_id: PropTypes.string,
        url: PropTypes.string
      }),
      redirect: PropTypes.shape({
        auth_token: PropTypes.string
      }),
      status: PropTypes.string
    }),
    setPageLoadingText: PropTypes.func.isRequired,
    setPageLoading: PropTypes.func.isRequired
  }).isRequired
};

export default inject(stores => {
  return {
    store: stores.store.source
  };
})(observer(CardDeviceDataCollectionComponent));
